import type { UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import { ENV } from '../env.utils';

export class OneAPIHelper {
  static isLoggedIn(): boolean {
    const userAPI = getAPI<UserAPI>('userAPI');
    const loggedIn = userAPI?.isLoggedIn();

    if (loggedIn) {
      const user = userAPI?.getUser();

      // check if is not guest user
      if (user?.code !== '5cbdb800dbab3e44afeae867') {
        return true;
      }
    }

    return false;
  }
}

// temporally function until one api evolve
export function uploadFile(
  file: File,
  fileAlias = 'file',
  handler: (event: ProgressEvent<XMLHttpRequestEventTarget>, file: File) => void,
): XMLHttpRequest {
  const formData = new FormData();
  formData.set(fileAlias, file, file.name);

  const xhr = new XMLHttpRequest();
  xhr.upload.addEventListener('progress', (event) => handler(event, file));
  xhr.open('POST', `${ENV.getKey('BASE_API_URL') + ENV.getKey('APPLICATION_IDENTIFIER')}/_social/_post/_upload`, true);
  xhr.setRequestHeader('Authorization', `Bearer ${ENV.getToken() ?? ''}`);
  xhr.setRequestHeader('X-explorer-account-token', ENV.getKey('ORGANIZATION_IDENTIFIER'));
  xhr.send(formData);
  return xhr;
}
